(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["havana-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const popup = document.getElementById('HavanaWelcomePopup');
      if (!popup || popup.dataset.initialized || typeof popup.showModal !== 'function') return;
      popup.dataset.initialized = 'true';
      const form = popup.querySelector('form');
      const signup = popup.querySelector('.hwp-signup');
      const success = popup.querySelector('.hwp-success');
      const storageKey = 'havana_eg_welcome_popup_v1';
      const pendingKey = 'havana_eg_welcome_pending';
      const fiveDays = 5 * 24 * 60 * 60 * 1000;
      const read = (key, session = false) => { try { return (session ? sessionStorage : localStorage).getItem(key); } catch (_) { return null; } };
      const write = (key, value, session = false) => { try { (session ? sessionStorage : localStorage).setItem(key, value); } catch (_) {} };
      const remove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
      let state = {};
      try { state = JSON.parse(read(storageKey) || '{}'); } catch (_) {}
      let fired = false;
      let timer;
      let previousOverflow;
      let interacted = false;
      const stopTriggers = () => {
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('pointerdown', startTimer);
        window.removeEventListener('keydown', startTimer);
      };
      function startTimer() {
        if (interacted || fired) return;
        interacted = true;
        timer = setTimeout(open, 5000);
        window.removeEventListener('pointerdown', startTimer);
        window.removeEventListener('keydown', startTimer);
      }
      const open = () => {
        if (fired || popup.open) return;
        fired = true;
        stopTriggers();
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        popup.showModal();
        (success.hidden ? popup.querySelector('.hwp-close') : success.querySelector('h2')).focus({preventScroll:true});
      };
      const close = () => {
        write(storageKey, JSON.stringify({...state, dismissedUntil: Date.now() + fiveDays}));
        stopTriggers();
        popup.close();
      };
      function onScroll() {
        startTimer();
        const height = document.documentElement.scrollHeight - window.innerHeight;
        if (height > 0 && window.scrollY / height >= 0.3) open();
      }
      popup.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; });
      popup.querySelector('.hwp-close').addEventListener('click', close);
      popup.querySelector('.hwp-continue').addEventListener('click', close);
      popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
      popup.addEventListener('click', event => {
        if (event.target !== popup) return;
        const rect = popup.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      });
      form.addEventListener('submit', () => {
        if (form.checkValidity()) write(pendingKey, String(Date.now()), true);
      });
      popup.querySelector('.hwp-code').addEventListener('click', async () => {
        const status = popup.querySelector('.hwp-copy-status');
        try {
          if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText('HAVANA10');
          else {
            const field = document.createElement('textarea');
            field.value = 'HAVANA10';
            field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
            popup.appendChild(field);
            field.select();
            const copied = document.execCommand('copy');
            field.remove();
            if (!copied) throw new Error('copy');
          }
          status.textContent = status.dataset.copied;
        } catch (_) { status.textContent = status.dataset.failed; }
      });
      const pending = Number(read(pendingKey, true));
      const returned = pending > 0 && Date.now() - pending < 30 * 60 * 1000;
      if (returned && success.dataset.posted === 'true') {
        signup.hidden = true;
        success.hidden = false;
        state = {subscribed:true};
        write(storageKey, JSON.stringify(state));
        remove(pendingKey);
        open();
      } else if (returned && success.dataset.errors === 'true') {
        remove(pendingKey);
        open();
      } else if (!state.subscribed && !(Number(state.dismissedUntil) > Date.now())) {
        window.addEventListener('pointerdown', startTimer, {once:true, passive:true});
        window.addEventListener('keydown', startTimer, {once:true});
        window.addEventListener('scroll', onScroll, {passive:true});
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
